import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from 'src/config';
import { getAuthAccessToken } from 'src/configuration/tokenHandling/authSlice';
import { createErrorResponse, createSuccessResponse } from 'src/services/responseCreator';

const TAG_TYPE_FILES = 'Files';
const TAG_TYPE_FILE = 'File';
const POST = 'POST';
const url = config.backend.confLogic.CONFLOGIC_SERVICE;
const path = config.backend.confLogic.CONFLOGIC_PATH;
const baseQuery = fetchBaseQuery({
    baseUrl: url,
    prepareHeaders: (headers, { getState }) => {
        headers.set('Content-Type', 'application/octet-stream');
        const token = getAuthAccessToken(getState());
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    },
});
export const conflogicApi = createApi({
    reducerPath: 'conflogicApi',
    baseQuery,
    tagTypes: [TAG_TYPE_FILES],
    endpoints: (builder) => ({
        getFile: builder.query({
            query: () => ({
                url: path,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            providesTags: [TAG_TYPE_FILE],
        }),
        postFile: builder.mutation({
            query: (file) => ({
                url: path,
                method: POST,
                body: file,
            }),
            transformResponse: (response, meta, arg) => {
                return createSuccessResponse(response, meta, arg);
            },
            transformErrorResponse: (response, meta, arg) => {
                return createErrorResponse(response, meta, arg, 'Error on uploading file');
            },
            invalidatesTags: [TAG_TYPE_FILES],
        }),
    }),
});

// Export hooks for usage in function components which are auto-generated based on defined endpoints
export const { useGetFileQuery, usePostFileMutation, useLazyGetFileQuery } = conflogicApi;
